import { Checkbox, Grid } from '@material-ui/core';
import CustomTextField from 'components/Input/CustomTextField';
import { useState } from 'react';
import CustomRadio from 'components/CustomRadio';

const useProgressReportData = ({
    isPermission,
    data,
    postData,
    onValueUpdate = (key, value) => {},
    onValidationUpdate = (key, isValid) => {},
    clearKeys,
    forceErrorDisplay,
    removeRequest,
}) => {
    const getValue = (key) => {
        if ((postData[key] === null || postData[key] === undefined) && removeRequest.includes(key)) {
            return null;
        }
        return postData?.[key] ?? data?.[key];
    };

    const checkIsAmendmentMadeEnabled = (value) => {
        if (value === true || value === 0) {
            return true;
        }

        return false;
    };

    const defaultRows = [
        {
            id: 0,
            changeType: 'Study Extension',
            amendmentMade: null,
            reportedBefore: null,
            nature: null,
            version: null,
            amendmentMadeOperators: [
                { key: true, label: 'Yes' },
                { key: false, label: 'No' },
            ],
            reportedBeforeOperators: [
                { key: true, label: 'Yes' },
                { key: false, label: 'No' },
            ],
        },
        {
            id: 1,
            changeType: 'Investigator',
            amendmentMade: null,
            reportedBefore: null,
            nature: null,
            version: null,
            amendmentMadeOperators: [
                { key: true, label: 'Yes' },
                { key: false, label: 'No' },
            ],
            reportedBeforeOperators: [
                { key: true, label: 'Yes' },
                { key: false, label: 'No' },
            ],
        },
        {
            id: 2,
            changeType: 'Study Protocol',
            amendmentMade: null,
            reportedBefore: null,
            nature: null,
            version: null,
            amendmentMadeOperators: [
                { key: true, label: 'Yes' },
                { key: false, label: 'No' },
            ],
            reportedBeforeOperators: [
                { key: true, label: 'Yes' },
                { key: false, label: 'No' },
            ],
        },
        {
            id: 3,
            changeType: 'Informed Consent Form',
            amendmentMade: null,
            reportedBefore: null,
            nature: null,
            version: null,
            amendmentMadeOperators: [
                { key: 0, label: 'Yes' },
                { key: 1, label: 'No' },
                { key: 2, label: 'N/A' },
            ],
            reportedBeforeOperators: [
                { key: true, label: 'Yes' },
                { key: false, label: 'No' },
            ],
        },
        {
            id: 4,
            changeType: 'Others(Please specify)',
            amendmentMade: null,
            reportedBefore: null,
            nature: null,
            version: null,
            amendmentMadeOperators: [
                { key: 0, label: 'Yes' },
                { key: 1, label: 'No' },
                { key: 2, label: 'N/A' },
            ],
            reportedBeforeOperators: [
                { key: true, label: 'Yes' },
                { key: false, label: 'No' },
            ],
        },
    ];

    const [rows] = useState(defaultRows);

    const lookupTable = {
        'Study Extension': {
            amendmentKey: 'studyExtensionAmendment',
            reportKey: 'studyExtensionReported',
            natureKey: 'studyExtensionNature',
            approveKey: 'studyExtensionApprovedVersion',
        },
        Investigator: {
            amendmentKey: 'investigatorAmendment',
            reportKey: 'investigatorReported',
            natureKey: 'investigatorNature',
            approveKey: 'investigatorApprovedVersion',
        },
        'Study Protocol': {
            amendmentKey: 'studyProtocolAmendment',
            reportKey: 'studyProtocolReported',
            natureKey: 'studyProtocolNature',
            approveKey: 'studyProtocolApprovedVersion',
        },
        'Informed Consent Form': {
            amendmentKey: 'informedConsentFormAmendment',
            reportKey: 'informedConsentFormReported',
            natureKey: 'informedConsentFormNature',
            approveKey: 'informedConsentFormApprovedVersion',
        },
        'Others(Please specify)': {
            amendmentKey: 'othersAmendment',
            reportKey: 'othersReported',
            natureKey: 'othersNature',
            approveKey: 'othersApprovedVersion',
        },
    };

    const getAmendmentDisabled = (params) => {
        if (params.row.changeType === 'Others(Please specify)') {
            return !getValue('isOthers');
        }

        return !isPermission;
    };

    const columns = [
        {
            field: 'changeType',
            headerName: '',
            width: 200,
            renderCell: (params) => {
                if (params.row.id === 4) {
                    return (
                        <div>
                            <Checkbox
                                disabled={params.row.disabled || !isPermission}
                                color="primary"
                                style={{ padding: 0 }}
                                checked={getValue('isOthers')}
                                onChange={(e) => {
                                    onValueUpdate('isOthers', e.target.checked);

                                    if (!e.target.checked) {
                                        clearKeys([
                                            'otherDocumentType',
                                            'othersAmendment',
                                            'othersReported',
                                            'othersNature',
                                            'othersApprovedVersion',
                                        ]);
                                    }
                                }}
                            />{' '}
                            {params.row.changeType}
                            <div style={{ marginTop: 15 }}>
                                <CustomTextField
                                    value={getValue('otherDocumentType')}
                                    textAreaMinRow={1}
                                    placeholder={'Document Type'}
                                    disabled={!isPermission || !getValue('isOthers')}
                                    debounceChange
                                    forceErrorDisplay={forceErrorDisplay}
                                    validators={getValue('isOthers') ? ['isRequired'] : []}
                                    maxLength={255}
                                    isValidValue={(isValid) => {
                                        onValidationUpdate('otherDocumentType', isValid);
                                    }}
                                    onChange={(e) => {
                                        onValueUpdate('otherDocumentType', e.target.value);
                                    }}
                                />
                            </div>
                        </div>
                    );
                }
                return params.row.changeType;
            },
        },
        {
            field: 'amendmentMade',
            headerName: 'Amendment Made',
            width: 250,
            renderCell: (params) => {
                return (
                    <div>
                        <CustomRadio
                            disabled={getAmendmentDisabled(params) || !isPermission}
                            isRequired={
                                params.row.changeType !== 'Others(Please specify)' ||
                                (getValue('isOthers') && params.row.changeType === 'Others(Please specify)')
                            }
                            forceErrorDisplay={forceErrorDisplay}
                            isValidValue={(isValid) => {
                                onValidationUpdate(lookupTable[params.row.changeType]['amendmentKey'], isValid);
                            }}
                            onChange={(e) => {
                                onValueUpdate(
                                    lookupTable[params.row.changeType]['amendmentKey'],
                                    JSON.parse(e.target.value),
                                );

                                if (
                                    JSON.parse(e.target.value) === false ||
                                    JSON.parse(e.target.value) === 1 ||
                                    JSON.parse(e.target.value) === 2
                                ) {
                                    clearKeys([
                                        lookupTable[params.row.changeType]['reportKey'],
                                        lookupTable[params.row.changeType]['natureKey'],
                                        lookupTable[params.row.changeType]['approveKey'],
                                    ]);
                                }
                            }}
                            value={getValue(lookupTable[params.row.changeType]['amendmentKey'])}
                            operators={params.row.amendmentMadeOperators}
                        />
                    </div>
                );
            },
        },
        {
            field: 'reportedBefore',
            headerName: 'Reported before?',
            tooltip: 'Please submit Protocol Amendment Application before the changes',
            width: 170,
            renderCell: (params) => {
                console.log('170958 useProgressReportData.js data', postData, params.row.changeType);
                console.log(
                    '170958 useProgressReportData.js data 2',
                    lookupTable[params.row.changeType]['reportKey'],
                    getValue(),
                );
                return (
                    <CustomRadio
                        disabled={
                            !isPermission ||
                            !checkIsAmendmentMadeEnabled(getValue(lookupTable[params.row.changeType]['amendmentKey']))
                        }
                        isRequired={checkIsAmendmentMadeEnabled(
                            getValue(lookupTable[params.row.changeType]['amendmentKey']),
                        )}
                        forceErrorDisplay={forceErrorDisplay}
                        isValidValue={(isValid) => {
                            onValidationUpdate(lookupTable[params.row.changeType]['reportKey'], isValid);
                        }}
                        onChange={(e) => {
                            onValueUpdate(lookupTable[params.row.changeType]['reportKey'], JSON.parse(e.target.value));

                            // checkIsAmendmentMadeEnabled(getValue(lookupTable[params.row.changeType]['amendmentKey']));
                        }}
                        value={getValue(lookupTable[params.row.changeType]['reportKey'])}
                        operators={params.row.reportedBeforeOperators}
                    />
                );
            },
        },
        {
            field: 'nature',
            headerName: 'Nature of change',
            // tooltip: '...',
            width: 400,
            renderCell: (params) => {
                return (
                    <CustomTextField
                        disabled={
                            !isPermission ||
                            !checkIsAmendmentMadeEnabled(getValue(lookupTable[params.row.changeType]['amendmentKey']))
                        }
                        isTextArea={params.row.id === 4}
                        debounceChange
                        value={getValue(lookupTable[params.row.changeType]['natureKey'])}
                        forceErrorDisplay={forceErrorDisplay}
                        validators={
                            checkIsAmendmentMadeEnabled(getValue(lookupTable[params.row.changeType]['amendmentKey']))
                                ? ['isRequired']
                                : []
                        }
                        maxLength={params.row.id === 4 ? 500 : 255}
                        isValidValue={(isValid) => {
                            onValidationUpdate(lookupTable[params.row.changeType]['natureKey'], isValid);
                        }}
                        onChange={(e) => {
                            onValueUpdate(lookupTable[params.row.changeType]['natureKey'], e.target.value);
                        }}
                    />
                );
            },
        },
        {
            field: 'version',
            headerName: 'Approved version',
            // tooltip: '...',
            width: 150,
            renderCell: (params) => {
                return (
                    <Grid container>
                        <CustomTextField
                            disabled={
                                !isPermission ||
                                !checkIsAmendmentMadeEnabled(
                                    getValue(lookupTable[params.row.changeType]['amendmentKey']),
                                )
                            }
                            isTextArea={params.row.id === 4}
                            debounceChange
                            value={getValue(lookupTable[params.row.changeType]['approveKey'])}
                            forceErrorDisplay={forceErrorDisplay}
                            validators={
                                checkIsAmendmentMadeEnabled(
                                    getValue(lookupTable[params.row.changeType]['amendmentKey']),
                                )
                                    ? ['isRequired']
                                    : []
                            }
                            maxLength={params.row.id === 4 ? 500 : 255}
                            isValidValue={(isValid) => {
                                onValidationUpdate(lookupTable[params.row.changeType]['approveKey'], isValid);
                            }}
                            onChange={(e) => {
                                onValueUpdate(lookupTable[params.row.changeType]['approveKey'], e.target.value);
                            }}
                        />
                    </Grid>
                );
            },
        },
    ];

    return { columns, rows };
};
export default useProgressReportData;
